import React from "react";
import { withStyles } from "@material-ui/core";
import Select from "../../../../../common/StyledSelect";
import { compose } from "recompose";
import { withSnackbar } from "notistack";
import formStyles from "../../../formStyles";
import { isEqual } from "lodash/lang";
import WithDrawer from "../../../../Dispatch/Common/Drawer/WithDrawer";
import { postData } from "../../../../../../api/componentAPIs";
import Action from "./Action";

class UpdateForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTerminalData:
        this.props.selectedTerminalData || this.getDefaultTerminalInfo(),
      errorInfo: {},
    };
  }

  componentDidUpdate(prevProps) {
    if (
      !isEqual(this.props.selectedTerminalData, prevProps.selectedTerminalData)
    ) {
      this.setState({
        selectedTerminalData:
          this.props.selectedTerminalData || this.getDefaultTerminalInfo(),
        errorInfo: {},
      });
    }
  }

  getDefaultTerminalInfo() {
    return {
      terminalCode: null,
      accessibleTerminals: [],
    };
  }

  handleChange = (name) => (value) => {
    if (name === "terminalCode") {
      value = value?.label;
    } else if (name === "accessibleTerminals") {
      value = value?.map((x) => x.label);
    }
    this.setState((state) => ({
      selectedTerminalData: {
        ...state.selectedTerminalData,
        [name]: value,
      },
      errorInfo: {
        ...state.errorInfo,
        [name]: this.getFieldError(name, value),
      },
    }));
    if (name === "terminalCode" && this.props.isCreateTerminalFlow) {
      this.replaceWithAvailableAccessibleTerminals(value);
    }
  };

  replaceWithAvailableAccessibleTerminals = (terminalCode) => {
    const accessibleTerminals =
      this.props.accessibleTerminalData.find(
        (accessibleTerminal) => accessibleTerminal.terminalCode === terminalCode
      )?.accessibleTerminals ?? [];
    this.setState((prevState) => ({
      ...prevState,
      selectedTerminalData: {
        ...prevState.selectedTerminalData,
        accessibleTerminals,
      },
    }));

    if (accessibleTerminals.length) {
      this.props.updateCreateTerminalToUpdateTerminal();
    }
  };

  getFieldError = (field, value) => {
    switch (field) {
      case "terminalCode":
        return value ? null : `* Required`;
      case "accessibleTerminals":
        if (!this.props.isCreateTerminalFlow) {
          return null;
        }
        return value?.length ? null : "* Required";
      default:
        return null;
    }
  };

  getErrorInfo = () => {
    const errorInfo = {};
    Object.keys(this.state.selectedTerminalData).forEach((fieldName) => {
      errorInfo[fieldName] = this.getFieldError(
        fieldName,
        this.state.selectedTerminalData[fieldName]
      );
    });
    this.setState({
      errorInfo,
    });
    return errorInfo;
  };

  updateTerminal = () => {
    const errorInfo = this.getErrorInfo();
    const error = Object.values(errorInfo).filter((value) => value).length;
    if (!error) {
      this.onCreateOrUpdateTerminal();
    }
  };

  onCreateOrUpdateTerminal = () => {
    const { terminalCode, accessibleTerminals } =
      this.state.selectedTerminalData;
    const { isCreateTerminalFlow } = this.props;
    const requestParams = {
      userTerminal: this.props.terminalCode,
      terminalCode,
      accessibleTerminals: accessibleTerminals ?? [],
    };
    this.props.updateModel({
      selectedTerminal: terminalCode,
      terminalUpdateInProgress: true,
    });
    postData(this.props.updateAPI, requestParams).then(
      (response) => {
        if (Math.trunc(response.status / 100) === 2) {
          if (isCreateTerminalFlow) {
            this.props.enqueueSnackbar(
              `Created accessible terminals for ${terminalCode}`,
              {
                variant: "success",
              }
            );
          } else {
            this.props.enqueueSnackbar(`Updated terminal ${terminalCode}`, {
              variant: "success",
            });
          }
          this.props.updateModel({
            selectedTerminal: terminalCode,
            terminalUpdateInProgress: false,
            showTerminalUpdatePanel: false,
            refreshDataList:true
          });
          return;
        }
        this.handleError(response.status);
      },
      () => {
        this.handleError();
      }
    );
  };

  handleError = (statusCode) => {
    const {terminalCode, isCreateTerminalFlow} = this.props;
    this.props.updateModel({
      selectedTerminal: terminalCode,
      terminalUpdateInProgress: false
    });
    if (statusCode === 403) {
      return;
    }
    const message = isCreateTerminalFlow
      ? `Error creating accessible terminals for ${terminalCode}`
      : `Error updating terminal ${terminalCode}`;
    this.props.enqueueSnackbar(message, { variant: 'error' });
  };

  render() {
    const { classes, isCreateTerminalFlow, terminalUpdateInProgress } =
      this.props;
    const {
      selectedTerminalData: { terminalCode, accessibleTerminals },
      errorInfo,
    } = this.state;
    const submitButtonLabel = isCreateTerminalFlow ? "Add" : "Update";
    return (
      <>
        <div className={classes.feederTerminalTitle}>
          {isCreateTerminalFlow
            ? "Add Accessible Terminals"
            : "Update Accessible Terminals"}
        </div>
        <div className={classes.feederTerminalContainer}>
          <form className={classes.form} noValidate>
            <div className={classes.flexRow}>
              <Select
                textFieldProps={{
                  id: "terminalCode",
                  label: "Terminal",
                  variant: "outlined",
                  helperText: errorInfo.terminalCode,
                }}
                value={terminalCode}
                error={Boolean(errorInfo.terminalCode)}
                onChange={this.handleChange("terminalCode")}
                data={this.props.terminalOptions}
              />
            </div>
            <div className={classes.flexRow}>
              <Select
                textFieldProps={{
                  id: "accessibleTerminals",
                  label: "Accessible Terminals",
                  variant: "outlined",
                  helperText: errorInfo.accessibleTerminals,
                }}
                value={accessibleTerminals?.length ? accessibleTerminals : ""}
                error={Boolean(errorInfo.accessibleTerminals)}
                isMulti
                onChange={this.handleChange("accessibleTerminals")}
                data={this.props.terminalOptions?.filter(
                  (option) => option.label !== terminalCode
                )} // remove default terminal from selectable option
              />
            </div>
          </form>
          <Action
            onClose={this.props.onClose}
            onConfirm={this.updateTerminal}
            isCreateTerminalFlow={isCreateTerminalFlow}
            terminalUpdateInProgress={terminalUpdateInProgress}
            submitButtonLabel={submitButtonLabel}
          />
        </div>
      </>
    );
  }
}

export default compose(
  withStyles(formStyles),
  withSnackbar,
  WithDrawer
)(UpdateForm);
